"use client";

import { Camera, Palette, Lightbulb, Film } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SetDesignAndPropCoordination() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const icons = [{
    Icon: Camera,
    label: "Camera Work"
  }, {
    Icon: Palette,
    label: "Set Design"
  }, {
    Icon: Lightbulb,
    label: "Lighting"
  }, {
    Icon: Film,
    label: "Direction"
  }];
  return <section className="relative overflow-hidden bg-background py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div ref={contentRef} className={`space-y-8 transition-all duration-700 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <div className="space-y-4">
              <h2 className="font-display text-4xl font-bold tracking-tight text-foreground lg:text-5xl xl:text-6xl">
                Cinematic Excellence in Every Frame
              </h2>
              <p className="text-lg leading-relaxed text-muted-foreground lg:text-xl">
                Our meticulous approach to set design and prop coordination ensures that every element on screen contributes to the story. From lighting rigs to camera angles, we orchestrate the perfect visual symphony.
              </p>
            </div>

            {}
            <div className="grid grid-cols-2 gap-6 sm:grid-cols-4">
              {icons.map((item, i) => {
              const {
                Icon,
                label
              } = item;
              return <div key={label} data-index={i} className="group flex flex-col items-center gap-3 text-center transition-all duration-300 hover:scale-105">
                    <div className="flex size-14 items-center justify-center rounded-full border-2 border-primary/20 bg-primary-light/50 transition-all duration-300 group-hover:border-primary group-hover:bg-primary group-hover:shadow-lg group-hover:shadow-primary/30">
                      <Icon className="size-6 text-primary transition-all duration-300 group-hover:animate-pulse group-hover:text-white" />
                    </div>
                    <span className="text-sm font-medium text-foreground transition-colors group-hover:text-primary-dark">
                      {label}
                    </span>
                  </div>;
            })}
            </div>

            {}
            <div className={`transition-all duration-700 delay-300 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
              <Link to="/#portfolio">
                <Button size="lg" className="group shadow-lg hover:shadow-xl hover:shadow-primary/20">
                  Explore Our Portfolio
                  <Film className="transition-transform duration-300 group-hover:translate-x-1" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div className="relative h-[500px] overflow-hidden rounded-2xl shadow-strong lg:h-[600px]">
            <div className="group relative size-full">
              <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520135/img/cinematic_film_set_lighting_production.png)] transition-all duration-700 group-hover:scale-105 group-hover:brightness-110" style={{
              willChange: "transform, filter"
            }} />
              <div className="absolute inset-0 bg-gradient-to-t from-dark-background/60 via-transparent to-transparent opacity-60 transition-opacity duration-500 group-hover:opacity-40" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}